/**
 * Logout – SVG icon.
 */
import Screen from '@screen';

export default function LogoutIcon({
  width,
  height,
  margin,
}: {
  width?: number;
  height?: number;
  margin?: string;
}) {
  return (
    <svg
      width={(width ? width : 83) * Screen.widthRatio}
      height={(height ? height : 83) * Screen.widthRatio}
      viewBox='0 0 83 83'
      style={{ margin: margin ? margin : 0 }}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M80.0026 41.5H45.7804'
        stroke='url(#paint0_linear_settings_logout)'
        strokeWidth='6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M67.1666 54.3333L79.6278 41.8721C79.8331 41.6668 79.8331 41.3331 79.6278 41.1278L67.1666 28.6666'
        stroke='url(#paint1_linear_settings_logout)'
        strokeWidth='6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M58.6111 11.5556V9.41667C58.6111 5.87283 55.7382 3 52.1944 3H11.5556C6.83045 3 3 6.83045 3 11.5556V71.4444C3 76.1697 6.83045 80 11.5556 80H52.1944C55.7382 80 58.6111 77.127 58.6111 73.5833V71.4444'
        stroke='url(#paint2_linear_settings_logout)'
        strokeWidth='6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_settings_logout'
          x1='62.8915'
          y1='41.5'
          x2='62.8915'
          y2='42.5'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_settings_logout'
          x1='73.4742'
          y1='28.6666'
          x2='73.4742'
          y2='54.3333'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_settings_logout'
          x1='30.8056'
          y1='3'
          x2='30.8056'
          y2='80'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
      </defs>
    </svg>
  );
}
